import { API } from "../../utils/_HttpUtils";


function impersonateExit() {
    return new API().send("GET", "impersonations/leave");
}

export { impersonateExit };
